import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Document } from 'UI/Icons';
import msal, { loginRequest, getToken } from 'lib/msal';
import getEnvironment from 'lib/env';
import Button from '@mui/material/Button';

class AttachedDocuments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			documents: [],
			undo: this.props.translate('undo'),
			delete: this.props.translate('Delete'),
		};

		this.token = null;

		let request = loginRequest;
		request.scopes = [
			...getEnvironment().scopes,
			...request.scopes
		];

		getToken(request).then((response) => {
			this.token = response.accessToken;


			this.loadDocuments(this.props);
		});
	}

	UNSAFE_componentWillReceiveProps = (nextProps) => {
		this.loadDocuments(nextProps);
	}

	loadDocuments = (props) => {
		if (this.token == null) {
			return false;
		}

		if (props.documents != null) {
			if (typeof props.documents === 'string') {
				const documentString = props.documents.split(';');
				const documents = [];
				documentString.forEach((document) => {
					const documentObj = {
						name: document.indexOf("?") > 0 ? document.split("?")[0].substring(document.split("?")[0].lastIndexOf('/') + 1) : document.substring(document.lastIndexOf('/') + 1),
						url: document,
						remove: false,
					};

					documents.push(documentObj);
				});

				this.setState({ documents });
			} else {
				const documents = [];
				props.documents.forEach((document) => {
					var fileUrl = document.value;

					const documentObj = {
						name: document.name,
						url: fileUrl,
						remove: document.markedForDeletion != null ?
							document.markedForDeletion : false,
					};

					documents.push(documentObj);
				});

				this.setState({ documents });
			}
		}
	}

	removeDocument = (document) => {
		const documents = this.state.documents;

		const doc = documents.find(docItr => docItr.url == document.url);
		if (doc.remove) {
			document.remove = false;
		} else {
			document.remove = true;
		}

		this.setState({ documents });

		this.props.removeInstruction(document.url, document.remove);
	}

	renderDocuments = () => {
		if (this.props.documents !== null) {
			const undo = this.state.undo;
			const deleteTitle = this.state.delete;
			const primaryButtonSx = { backgroundColor: '#FFFFFF', textTransform: 'none' };
			const secondaryButtonSx = { textTransform: 'none' };

			return this.state.documents.map((document, i) => {
				if (document.url !== '') {
					return (

						<Button
							component="a"
							href={document.url}
							target="_blank"
							variant="outlined"
							size="large"
							className="document-button"
							sx={primaryButtonSx}
							startIcon={<Document />}

						>
							<strong>{document.name}</strong>

							{
								this.props.removeInstruction != null ?
									<Button variant="outlined" size="small" className="button-secondary" sx={secondaryButtonSx} onClick={() => { this.removeDocument(document); }}>
										{document.remove ? undo : deleteTitle}
									</Button>
									: null
							}

						</Button >
					);
				}
			});
		}
	}

	render() {
		return (
			<div className="attached-documents">
				{this.renderDocuments()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
	};
}

export default connect(mapStateToProps)(AttachedDocuments);